export const MIXED_PRIORITY_ID = 'mixed';
export const TOTAL_PRIORITY_ID = 'total';
